var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      _vm._m(0),
      _c("p", { staticClass: "text-muted mb-4" }, [
        _vm._v(
          " Anexe documentos complementares que possam ser solicitados durante o processo de análise (opcional). "
        )
      ]),
      _c(
        "b-alert",
        { staticClass: "mb-4", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("h6", { staticClass: "alert-heading" }, [
              _c("i", { staticClass: "feather icon-info mr-1" }),
              _vm._v(" Informações sobre Anexos ")
            ]),
            _c("hr"),
            _c("ul", { staticClass: "mb-0" }, [
              _c("li", [
                _c("strong", [_vm._v("Formatos aceitos:")]),
                _vm._v(" PDF, DOC, DOCX, XLS, XLSX, JPG, PNG")
              ]),
              _c("li", [
                _c("strong", [_vm._v("Tamanho máximo:")]),
                _vm._v(" 10MB por arquivo")
              ]),
              _c("li", [
                _c("strong", [_vm._v("Quantidade:")]),
                _vm._v(" Você pode anexar múltiplos arquivos")
              ]),
              _c("li", [
                _c("strong", [_vm._v("Opcional:")]),
                _vm._v(
                  " Este step pode ser pulado se não houver documentos adicionais"
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Anexos Complementares (se solicitado)" } },
                [
                  _c("b-form-file", {
                    staticClass: "mb-3",
                    attrs: {
                      value: null,
                      multiple: "",
                      placeholder:
                        "Clique para selecionar os arquivos ou arraste aqui...",
                      "drop-placeholder": "Solte os arquivos aqui...",
                      accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
                      state: _vm.getFieldState("additional_attachments"),
                      disabled: _vm.disabled
                    },
                    on: { input: _vm.handleFileUpload }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-upload mr-1" }),
                    _vm._v(
                      " Selecione um ou mais arquivos para anexar. Todos os anexos são opcionais. "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Erro no upload dos anexos ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.hasUploadedFiles
        ? _c(
            "div",
            { staticClass: "uploaded-files mt-4" },
            [
              _vm._m(1),
              _c(
                "b-card",
                [
                  _c(
                    "b-list-group",
                    _vm._l(_vm.formData.additional_attachments, function(
                      file,
                      index
                    ) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: index,
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "feather icon-file-text text-danger mr-2"
                            }),
                            _vm.getFileDownloadUrl(file)
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "mr-2 download-link text-primary",
                                    attrs: {
                                      href: _vm.getFileDownloadUrl(file),
                                      target: "_blank",
                                      title: "Baixar arquivo"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "feather icon-download"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _c("strong", [
                              _vm._v(_vm._s(file.metadata.original_name))
                            ]),
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getDocumentTypeLabel(
                                      file.metadata.document_type
                                    )
                                  ) +
                                  " "
                              ),
                              _c("small", { staticClass: "ml-2" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.formatFileSize(file.size)) +
                                    ")"
                                )
                              ]),
                              _c("small", { staticClass: "ml-2 text-muted" }, [
                                _vm._v(
                                  "[" +
                                    _vm._s(
                                      _vm.getFileExtension(file.file_name)
                                    ) +
                                    "]"
                                )
                              ])
                            ])
                          ]),
                          !_vm.disabled
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-danger",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFile(index)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-trash-2"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "no-attachments text-center p-4 border rounded bg-light"
            },
            [
              _c("i", {
                staticClass: "feather icon-folder text-muted",
                staticStyle: { "font-size": "2rem" }
              }),
              _vm._m(2)
            ]
          ),
      _vm.hasUploadedFiles
        ? _c(
            "b-alert",
            { staticClass: "mt-4", attrs: { variant: "success", show: "" } },
            [
              _c("div", { staticClass: "alert-body" }, [
                _c("h6", { staticClass: "alert-heading" }, [
                  _c("i", { staticClass: "feather icon-check mr-1" }),
                  _vm._v(" Anexos Prontos ")
                ]),
                _c("hr"),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.attachmentCount) +
                      " arquivo(s) anexado(s) com sucesso. Você pode adicionar mais arquivos ou continuar para o próximo passo. "
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Confirmar Remoção",
            centered: "",
            "hide-footer": ""
          },
          on: { hide: _vm.cancelRemove },
          model: {
            value: _vm.showRemoveConfirmModal,
            callback: function($$v) {
              _vm.showRemoveConfirmModal = $$v
            },
            expression: "showRemoveConfirmModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("i", {
              staticClass: "feather icon-trash-2 text-danger mb-2",
              staticStyle: { "font-size": "2rem" }
            }),
            _c("p", [_vm._v(" Tem certeza que deseja remover este arquivo? ")])
          ]),
          _c(
            "div",
            { staticClass: "text-center mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "danger" },
                  on: { click: _vm.confirmRemove }
                },
                [_vm._v(" Remover ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: { click: _vm.cancelRemove }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "feather icon-paperclip mr-2" }),
      _vm._v(" Anexos Complementares ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "text-muted mb-3" }, [
      _c("i", { staticClass: "feather icon-check-circle mr-1" }),
      _vm._v(" Arquivos Carregados ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-muted mt-2 mb-0" }, [
      _vm._v(" Nenhum anexo foi adicionado ainda."),
      _c("br"),
      _c("small", [
        _vm._v(
          "Este passo é opcional e pode ser pulado se não houver documentos complementares."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }